import React from 'react';
import { useSegmentDefinitions } from '../../edit-automation-template/useSegmentDefinitions';
import { SegmentsTable } from './SegmentsTable';
import { SegmentsTableLoading } from './SegmentsTableLoading';
import { SegmentsTableError } from './SegmentsTableError';

export const SegmentsManager: React.FC = () => {
  const { data: segmentsData, isLoading, error } = useSegmentDefinitions();

  const segments = segmentsData || [];

  if (isLoading) {
    return <SegmentsTableLoading />;
  }

  if (error) {
    return <SegmentsTableError error={error} />;
  }

  return <SegmentsTable segments={segments} />;
};
